import { Component, OnInit } from '@angular/core';
import {UserService} from 'src/app/services'
import { UserDetail, AccessUserInfo } from 'src/app/models';
@Component({
  selector: 'bart-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {
  bartRoleDescription:string;
  lastName:string;
  firstLastName:string;
  constructor(private userService:UserService) { }

  ngOnInit() {
    let userInfo:UserDetail=AccessUserInfo.getUserInfo()
    if(userInfo!=null)
    {
      this.firstLastName=userInfo.firstLastName
      this.bartRoleDescription=userInfo.bartRoleDescription
    }
  }

}
